import { ReactNode, FC, useState } from 'react';
import { ReactComponent as Chevron } from 'assets/vector/chevron.svg';

export const DataContainer: FC<{
  title: string;
  value: number;
  info?: ReactNode | undefined;
  children: any;
}> = ({ title, children, info }) => {
  const [isOpen, isOpenSet] = useState<boolean>(false);
  const toggle = () => isOpenSet((prev) => !prev);
  return (
    <div className={`DataContainer ${isOpen ? ' DataContainer--open' : ''}`}>
      <div className="DataContainer__wrapper">
        <h2 className="DataContainer__title" onClick={toggle}>
          <span className="DataContainer__title-text">{title}</span>
          <span className="DataContainer__title-icon">
            <Chevron />
          </span>
        </h2>
        <div className="DataContainer__content">{children}</div>
        <div className="DataContainer__info">{info}</div>
      </div>
    </div>
  );
};
